import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import RenderField from "../../../components/RenderField";
import { getRolesTranslations } from "../../../utils/getRolesTranslations";
export var GuarantorsSection = function (_a) {
    var guarantors = _a.guarantors;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    if (!guarantors || guarantors.length === 0) {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("div", null, formatMessage({ id: "ui-br-publishers.publishers.guarantors.empty" })))));
    }
    return (React.createElement(React.Fragment, null, guarantors.map(function (guarantor, index) {
        var _a, _b;
        return (React.createElement(React.Fragment, { key: index },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(RenderField, { label: formatMessage({
                            id: "ui-br-publishers.publishers.guarantors.field.label.firstName",
                        }), value: guarantor.firstName })),
                React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(RenderField, { label: formatMessage({
                            id: "ui-br-publishers.publishers.guarantors.field.label.lastName",
                        }), value: guarantor.lastName })),
                React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(RenderField, { label: formatMessage({
                            id: "ui-br-publishers.publishers.guarantors.field.label.email",
                        }), value: guarantor.email })),
                ((_b = (_a = guarantor.roles) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && (React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(RenderField, { label: formatMessage({
                            id: "ui-br-publishers.publishers.guarantors.role",
                        }), value: getRolesTranslations(intl, guarantor.roles[0]) }))))));
    })));
};
